import React from 'react'
import PropTypes from 'prop-types'
import { BrandsImage, BrandsMain } from './index.style'
import Container from '@components/Container'
import Spacer from '@components/Spacer'
import { GatsbyImage } from 'gatsby-plugin-image'
import BrandsGrid from '../BrandsGrid'
import { Heading2Serif } from '@components/TextStyles'

const Brands = ({ items }) => {
  const carouselItems = items.map(brand => (
    <BrandsImage>
      <GatsbyImage image={brand.gatsbyImageData} alt={brand.description} height="170" width="170" />
    </BrandsImage>
  ))

  return (
    <BrandsMain>
      <Container>
        <Spacer size={[80, 105]} />

        <Heading2Serif maxWidth={11}>Our Clients</Heading2Serif>

        <Spacer size={[20, 70]} />

        <BrandsGrid items={carouselItems} itemsPerRow={6} />

        <Spacer size={[60, 100]} />
      </Container>
    </BrandsMain>
  )
}

Brands.propTypes = {
  items: PropTypes.array,
}

export default Brands
